<template>
    <div class="">
        <div class="hero_section vh-100">
            <div class="hero_content">
                <div class="hero_desc text-center text-md-end">
                    Page Not Found
                </div>
                <h1 class="hero_title mega_text">
                    404
                </h1>
                <div class="hero_desc text-center text-md-start">
                    Page Not Found
                </div>
            </div>            
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
    }
}

</script>



// WEBPACK FOOTER //
// src/views/portfolio/Content/404.vue